import { Nav, NavItem, NavLink } from "reactstrap";
import React, { Fragment, useCallback, useState } from "react";
import CreateSubServiceModal from "../createSubServicesModal";
import CreateFormModal from "../createFormModal";

const TABS = [
  { id: "2", label: "Program Mapping" },
  { id: "3", label: "Edit Program" },
  { id: "4", label: "Member Benefits" },
  { id: "5", label: "New Member Benefits" },
];

const NavComponent = ({ callbackActive, activeTab }) => {
  const [isSubServiceModalOpen, setSubServiceModalOpen] = useState(false);
  const [isCreateFormModalOpen, setCreateFormModalModalOpen] = useState(false);

  const toggleSubService = useCallback(() => {
    setSubServiceModalOpen((s) => !s);
  }, []);

  const toggleCreateForm = useCallback(() => {
    setCreateFormModalModalOpen((s) => !s);
  }, []);

  return (
    <Fragment>
      <CreateSubServiceModal
        isOpen={isSubServiceModalOpen}
        toggle={toggleSubService}
      />
      <CreateFormModal
        isOpen={isCreateFormModalOpen}
        toggle={toggleCreateForm}
      />
      <Nav tabs>
        {TABS.map((tab) => (
          <NavItem key={tab.id}>
            <NavLink
              href="#"
              active={activeTab === tab.id}
              onClick={(e) => {
                e.preventDefault();
                callbackActive(tab.id);
              }}
              style={{
                cursor: "pointer",
                ...(activeTab === tab.id
                  ? {
                      borderColor: "#7366ff",
                      borderBottomColor: "transparent",
                      color: "#7366ff",
                      background: "rgba(115, 102, 255, 0.08)",
                      boxShadow: "0 -3px 8px rgba(115, 102, 255, 0.18)",
                      fontWeight: 600,
                    }
                  : {
                      background: "transparent",
                      color: "#6c757d",
                    }),
              }}
            >
              {tab.label}
            </NavLink>
          </NavItem>
        ))}
      </Nav>
    </Fragment>
  );
};

export default NavComponent;
